module.exports = __webpack_public_path__ + "static/media/logout.205185cb.svg";